/**
 * The MCP tab of Integrations: the person's MCP tokens and AI tool connections (with How to connect), then every tool
 * an AI tool can call. The tool list is written from the server's registry (``mcpTools.json``, kept current by
 * ``backend/tests/test_mcp_registry.py``), so the page shows exactly what MCP offers.
 */

import { scopeLabel } from '@/routes/account/mcpScopes';
import { TokensTab } from '@/routes/account/TokensTab';

import TOOLS from './mcpTools.json';

const CATEGORY_LABELS: Record<string, string> = { read: 'Reads', create: 'Adds', update: 'Changes' };

export function McpTools() {
  return (
    <section className="stack-sm" aria-labelledby="mcp-tools">
      <h2 id="mcp-tools" className="config-subhead">What an AI tool can do</h2>
      <p className="hint">Each tool needs its permission on the token. None runs AI: your AI tool does the reasoning on what it reads.</p>
      <div className="table-scroll">
        <table className="data zebra compact">
          <thead>
            <tr>
              <th scope="col">Tool</th>
              <th scope="col">Kind</th>
              <th scope="col">What it does</th>
              <th scope="col">Needs</th>
            </tr>
          </thead>
          <tbody>
            {TOOLS.map((tool) => (
              <tr key={tool.name}>
                <th scope="row" className="mono">{tool.name}</th>
                <td>
                  <span className="badge badge-neutral">{CATEGORY_LABELS[tool.category] ?? tool.category}</span>
                </td>
                <td>{tool.summary}</td>
                <td>{tool.needs.map(scopeLabel).join(', ')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export function McpTab() {
  return (
    <div className="stack-md">
      <TokensTab />
      <McpTools />
    </div>
  );
}
